module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3WzSJ"))).then(() => module.bundle.root('jnagv'));